"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ArchiveReopenResponse () {
        return ArchiveReopenResponse;
    },
    get BulkCreateCompetenciesResponse () {
        return BulkCreateCompetenciesResponse;
    },
    get CheckNameResponse () {
        return CheckNameResponse;
    },
    get ListCompetenciesResponse () {
        return ListCompetenciesResponse;
    },
    get SingleCompetencyResponse () {
        return SingleCompetencyResponse;
    }
});
const _zod = require("zod");
const _responsehelpers = require("../helpers/response-helpers");
const CompetencyLevelResponse = _zod.z.object({
    rank: _zod.z.number(),
    name: _zod.z.string(),
    description: _zod.z.string()
});
const UserActionResponse = _zod.z.object({
    user_id: _responsehelpers.ResponseObjectId,
    time_stamp: _zod.z.union([
        _zod.z.date(),
        _zod.z.string()
    ])
});
const CompetencyResponseItem = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    company_id: _responsehelpers.ResponseObjectId,
    name: _zod.z.string(),
    description: _zod.z.string(),
    is_company_wide: _zod.z.boolean(),
    status: _zod.z.enum([
        "active",
        "archived"
    ]),
    levels: _zod.z.array(CompetencyLevelResponse),
    rating_scale: _zod.z.object({
        options: _zod.z.array(_zod.z.object({
            value: _zod.z.number(),
            label: _zod.z.string()
        }))
    }).nullable(),
    created: UserActionResponse,
    updated: UserActionResponse
});
const ListCompetenciesResponse = _zod.z.object({
    competencies: _zod.z.array(CompetencyResponseItem),
    totalCount: _zod.z.number()
});
const SingleCompetencyResponse = _zod.z.object({
    competency: CompetencyResponseItem
});
const CheckNameResponse = _zod.z.object({
    available: _zod.z.boolean()
});
const ArchiveReopenResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const BulkCreateCompetenciesResponse = _zod.z.object({
    insertedIds: _zod.z.array(_zod.z.string())
});
